import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { extractErr } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useStoreBase } from "@/lib/store";

export default function DeliverLogin() {
  const nav = useNavigate();
  const { base } = useStoreBase();
  const home = `${base || ""}/deliver`;
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/deliver/login", form);
      nav(`${home}/orders`, { replace: true });
    } catch (err) {
      toast.error(extractErr(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center p-4" data-testid="deliver-login">
      <form onSubmit={submit} className="w-full max-w-sm bg-white text-slate-900 rounded-2xl p-6 space-y-4">
        <h1 className="text-2xl font-extrabold">Delivery panel</h1>
        <p className="text-sm text-slate-500">Sign in with the account your merchant created.</p>
        <div><Label>Email</Label><Input className="mt-1" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="deliver-email" /></div>
        <div><Label>Password</Label><Input className="mt-1" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="deliver-password" /></div>
        <Button type="submit" disabled={busy} className="w-full bg-violet-700" data-testid="deliver-submit">{busy ? "Signing in…" : "Sign in"}</Button>
      </form>
    </div>
  );
}
